import { fetcher } from "../../../utils/Axios";
import { useQuery } from "@tanstack/react-query";
import { GET_ON_TIME_START_END_PERCENTAGE_QUERY_KEY } from "../types/CommonTypes";
import { GET_ON_TIME_START_END_PERCENTAGE_RESPONSE } from "../types/ResponseTypes";

async function getOnTimeStartEndPercentage(tenantId: string, hospitalId: string, queryString: string): Promise<GET_ON_TIME_START_END_PERCENTAGE_RESPONSE> {
  const baseUrl = "analytics/on-time-starts-ends";
  const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
  
  const { data } = await fetcher({
    url,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetOnTimeStartEndPercentageQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [GET_ON_TIME_START_END_PERCENTAGE_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getOnTimeStartEndPercentage(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
} 